import { useSearchParams } from "react-router-dom";
import PickXiChrome from "../components/pickxi/PickXiChrome";
import ScheduleGameForm from "../components/pickxi/ScheduleGameForm";

/**
 * Issue #1316 (Pick XI coach 1 of 3; D297, D302) — `/coach-portal/games/schedule`,
 * Schedule a game (`CoachScheduleGame.dc.html`). Coach only, behind
 * `newUi("pick-xi")` (the route in `App.js`). `?game=<id>` opens it prefilled
 * for that game and saves with `PUT` (Edit the squad, D316 Q4).
 */
export default function CoachScheduleGame() {
  const [params] = useSearchParams();
  const gameId = params.get("game") || null;
  return (
    <PickXiChrome title="Schedule a game" testId="game-schedule-page">
      <ScheduleGameForm key={gameId || "new"} gameId={gameId} />
    </PickXiChrome>
  );
}
